import { io, Socket } from "socket.io-client";
import { WS_BASE_URL } from "../../utils/globals";

class WebSocketService {
  openSocket: Socket | null = null;

  connect(): Promise<void> {
    return new Promise((resolve) => {
      if (this.openSocket?.connected) {
        resolve();
        return;
      }

      if (this.openSocket) {
        this.openSocket.removeAllListeners();
        this.openSocket.disconnect();
        this.openSocket = null;
      }

      this.openSocket = io(`${WS_BASE_URL}/open`, {
        transports: ["websocket"],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 2000,
      });

      this.openSocket.on("connect", () => resolve());
      this.openSocket.on("connect_error", () => resolve());
    });
  }

  subscribeToRoom(roomname: string) {
    this.openSocket?.emit("subRoom", { roomname });
  }

  onMessage(event: string, callback: (data: any) => void) {
    this.openSocket?.on(event, callback);
  }

  offMessage(event: string, callback?: (data: any) => void) {
    if (callback) {
      this.openSocket?.off(event, callback);
    } else {
      this.openSocket?.off(event);
    }
  }

  disconnect() {
    if (this.openSocket) {
      this.openSocket.removeAllListeners();
      this.openSocket.disconnect();
      this.openSocket = null;
    }
  }
}

const webSocketService = new WebSocketService();
export default webSocketService;
